import { DecimalUtil } from '@orca-so/common-sdk'

import { APITokenInfo } from '@/utils/apis/helper'
import { format } from '@/utils/numeric'

import { TopCoinsDataItem } from './types'

export const TOP_COINS_TAB = {
  spot: 'spot',
}

export const COLUMNS_KEY = {
  index: 'index',
  tokenName: 'tokenName',
  balances: 'balances',
  marketCap: 'marketCap',
  holders: 'holders',
  volume24h: 'volume24h',
  diff24Hours: '24h%',
  chart: 'chart',
  actionsSpot: 'actionsSpot',
}

export const ACTION_TYPE = {
  trade: 'trade',
  withdraw: 'withdraw',
  deposit: 'deposit',
}

export const calculateMarketCap = (token: APITokenInfo) => {
  if (!token.price?.current_price || !token?.metadata?.total_supply) {
    return '--'
  }

  const currentPrice = token.price.current_price
  const currentSupply = token.metadata.total_supply

  return '$' + format(DecimalUtil.fromNumber(currentPrice).mul(currentSupply), 0)
}

export const getTradeRoute = (tokenSymbol: string, isDeposit?: boolean) => {
  if (isDeposit) {
    if (tokenSymbol === 'reUSD') return '/RENEC_reUSD'
    return `/reUSD_${tokenSymbol}`
  }

  if (tokenSymbol === 'reUSD') return '/reUSD_RENEC'
  return `/${tokenSymbol}_reUSD`
}

export const getColorStyle = (diffNumber: number) => ({
  color: diffNumber === 0 ? 'white' : diffNumber < 0 ? '#FF6701' : '#55B964',
})

export const mapDataTopCoinToken = (token: APITokenInfo, tokenBalance?: number): TopCoinsDataItem => {
  return {
    id: token.id,
    logo: token.logo_url,
    tokenMint: token.coin_address,
    tokenName: token.token_name,
    symbol: token.token_symbol,
    marketCapFormatted: calculateMarketCap(token),
    holders: token.metadata?.holders_count ? format(token.metadata.holders_count) : '--',
    price: token.price?.current_price
      ? '$' + format(token.price.current_price, 9)
      : '--',
    isHasChart: Number(token.chart_data?.length) > 0,
    // diff7Days: token.price?.diff_7_days_percent || 0,
    diff24Hours: token.price?.diff_24_hours_percent || 0,
    userBalance: format(tokenBalance || 0, {
      decimals: token.decimals,
      desiredLength: 10,
      rounding: 'up',
    }),
    volume24h: !Number(token.volume_24h)
      ? '$0'
      : Intl.NumberFormat('en', {
          style: 'currency',
          currency: 'USD',
          notation: 'compact',
          maximumSignificantDigits: 3,
        }).format(Number(token.volume_24h)),
  }
}
